/**
 * API Configuration for Admin Panel
 * Centralized API URL configuration for the entire admin application
 */

// API Configuration Function
export const getApiUrl = () => {
    let hostname = window.location.host;

    // Development environment detection - use proxy to avoid CORS
    if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
        // Use Vite proxy during development (no CORS preflight!)
        return "/api-proxy/index.php/api/";
    } else {
        // Production environment - direct API call
        return import.meta.env.VITE_API_BASE_URL;
    }
};

// Export the API URLs
export const APIUrl = getApiUrl();
export const AI_API_URL = import.meta.env.VITE_AI_API_URL;

// Export default configuration object
const apiConfig = {
    APIUrl,
    AI_API_URL,
    getApiUrl
};

export default apiConfig;
